module.exports = __webpack_public_path__ + "img/line-child2.7b70271e.png";